import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a67406ea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67406ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67406ea')) {
      api.createRecord('a67406ea', component.options)
    } else {
      api.reload('a67406ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a67406ea&scoped=true&", function () {
      api.rerender('a67406ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/information/index.vue"
export default component.exports